import styled from 'styled-components'

export const LaunchAlertText = styled.span`
  font-family: 'Work Sans';
  font-weight: 400;

  a {
    color: #000;
  }
`

export const LaunchAlertStrip = styled.div.attrs({
  className: 'dib h-100 mr1 bg-green',
})`
  flex-basis: 10px;
  flex-shrink: 0;
`



// WEBPACK FOOTER //
// ./src/components/LaunchAlert/index.style.js